import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Button } from 'reactstrap';
import { CSVLink } from "react-csv";
import moment from 'moment';

import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';
const headers1 = [
  { key: "r1", label: "" },
  { key: "r2", label: "" },
  { key: "r3", label: "" }
];
const headers2 = [
  { key: "r1", label: "" },
  { key: "r2", label: "" }
];
const Topic = ({ labels, data, fromDate, toDate, analyzeTicket }) => {
  const [csvData, setCSVData] = useState([]);
  useEffect(() => {
    let tablePrint = [];
    if (analyzeTicket === true) {
      tablePrint.push(
        { r1: "", r2: "Commonly Asked Questions" },
        {},
        { r1: "Start Date :" + fromDate, r2: "End Date :" + toDate },
        {},
        { r1: "Topic", r2: "Conversations" }
      );
    } else {
      tablePrint.push(
        { r1: "", r2: "Commonly Asked Questions", r3: "" },
        {},
        { r1: "Start Date :" + fromDate, r2: "", r3: "End Date :" + toDate },
        {},
        { r1: "Topic", r2: "Conversations", r3: "Messages" }
      );
    }

    if (data.length > 0) {
      data.map(elem => {
        if (analyzeTicket === true) {
          tablePrint.push({
            r1: elem.topic,
            r2: elem.conversations,
          })
        }
        else {
          tablePrint.push({
            r1: elem.topic,
            r2: elem.conversations,
            r3: elem.messages
          })
        }
      });
    } else {
      if (analyzeTicket === true) {
        tablePrint.push({
          r1: "No Topic Detected",
          r2: "",
        });
      } else {
        tablePrint.push({
          r1: "No Topic Detected",
          r2: "",
          r3: ""
        });
      }
    }

    setCSVData(tablePrint);
  }, [data, analyzeTicket]);


  const tableData = data && data.length === 0
    ? [{ topic: "No Topic Detected", conversations: "", messages: "" }]
    : data;

  return (
    <Card>
      <div style={{ padding: '15px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">
              <IntlMessages id='dashboards.common-asked' />
            </h5>
            <span className="text-muted text-small d-block">
              <IntlMessages id="dashboards.website-visitor-asking" />
            </span>
          </div>
        </div>
        <div className='float-right'>
          <CSVLink data={csvData} headers={analyzeTicket === true ? headers2 : headers1} filename="commonly-asked-questions.csv">
            <Button
              color="primary"
              outline
              size="xs"
            >
              <IntlMessages id='dashboards.download' />
            </Button>
          </CSVLink>
        </div>
      </div>
      <CardBody>
        <ReactTable
          data={tableData}
          columns={labels}
          defaultPageSize={5}
          filterable={false}
          showPageJump={true}
          PaginationComponent={DataTablePagination}
          showPageSizeOptions={true}
          defaultSorted={[
            {
              id: 'conversations',
              desc: true,
            },
          ]}
        />
      </CardBody>
    </Card>
  );
};

export default Topic;
